<template>
	<div class="problem">
		<el-form label-position="right" label-width="100px">
			<el-row :gutter="30">
				<el-col :span="12">
					<el-row :gutter="30" v-show="false">
						<el-col :span="24">
							<el-form-item label="id" class="item-style">
								<el-input v-model="problem.id" ></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="30">
						<el-col :span="24">
							<el-form-item label="标题" class="item-style">
								<el-input v-model="problem.title" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="30">
						<el-col :span="24">
							<el-form-item label="意见建议" class="item-style">
								<el-input v-model="problem.content" type="textarea" :rows="4" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>

				</el-col>

				<el-col :span="12">
					<el-row :gutter="30">
						<el-col :span="24" >
								<el-form-item label=" " class="item-style">
							<el-button size="medium" type="success" @click="handleSave">保存</el-button>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="30">
						<el-col :span="24">
							<el-form-item label="反馈" class="item-style">
								<el-input v-model="problem.feedback" type="textarea" :rows="4"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</el-form>

		<div v-viewer="options" style="margin: 20px;">
			<template v-for="image  in images">
				<img :src="[serverName+'/Common/showImgByStream.do?id='+image.id]" :data-source="image.imagePath" :key="image.imagePath"
				 style="width: 200px; height: 200px;">
			</template>
		</div>
		<el-dialog :close-on-click-modal="false"   v-dialogDrag title="图片列表" :visible.sync="upLoadImg" width="800px">
			<el-button size="medium" type="success" @click="submitUpload">上传</el-button>

			<el-upload action="234" ref="upload" :auto-upload="false" :on-change="handleChange" list-type="picture-card"
			 :on-preview="handlePictureCardPreview" multiple :on-remove="handleRemove">
				<i class="el-icon-plus"></i>
			</el-upload>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"   v-dialogDrag title="图片列表" :visible.sync="dialogShowImg" width="800px">
			<el-table v-loading="loading" :data="images" stripe border style="width: 99%;">
				<el-table-column type="index" label="序号" width="80 px" align="center">
				</el-table-column>
				<el-table-column prop="imageName" label="图片名" mini-width="95%">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="danger" @click="eletedImgPath(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>


	</div>
</template>
<script>
	import axios from '@/axios'

	import 'viewerjs/dist/viewer.css'
	import Viewer from 'v-viewer'
	import Vue from 'vue'
	Vue.use(Viewer)
	import {
		mapState
	} from 'vuex'
	export default {
		computed: {
			...mapState({
				problemId: state => state.system.problemId,
				serverName: state => state.app.serverName,
			})
		},
		data() {
			return {
				problem: {
					id: '',
					title: '',
					content: '',
					feedback: ''
				},
				upLoadImg: false,
				dialogShowImg: false,
				fileListTemp: [],
				formData: new FormData(),
				images: [],
				options: [],
			}
		},
		methods: {
			showUploadImg() {
				this.upLoadImg = true
			},
			submitUpload() {
				if (this.fileListTemp.length < 1) {
					this.$message({
						type: 'warn',
						message: '请添加图片！！！'
					});
					return;
				}
				this.formData.append('fid', this.problemId)
				for (let i = 0; i < this.fileListTemp.length; i++) {
					this.formData.append('file', this.fileListTemp[i].raw)
				}
				axios.post('Common/uploadImage.do', this.formData).then(response => {

					if (response.data.code == '0') {
						this.$message({
							type: 'success',
							message: '导入成功!',
						});
						this.formData = new FormData()
						this.fileListTemp = []
						this.$refs.upload.submit()
						this.showImages()
					} else {
						this.$message({
							type: 'error',
							message: '导入失败' + response.data
						});
						this.fileListTemp = []
						this.formData = new FormData()
						this.$refs.upload.submit()
					}

				})
			},
			handleSave() {
				var url = 'framework/SysProblem/saveFeedBack.do'
				var param = {
					json: JSON.stringify(this.problem),
				}
				axios.post(url, param).then(response => {
					if (response.data.code == '0') {
						this.$message({
							type: 'success',
							message: '保存成功!',
						});
					} else {
						this.$message({
							type: 'error',
							message: '保存失败' + response.data
						});

					}
				})
			},

			handleChange(file, fileList) {
				this.fileListTemp = fileList
			},
			handleRemove(file, fileList) {
				this.fileListTemp = fileList
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			getByPrimaryKey() {
				var url = 'framework/SysProblem/queryByPrimaryKey.do'
				var param = {
					id: this.problemId,
				}
				axios.get(url, param).then(response => {
					if (response.data.code == '0') {
						if (response.data.data) {
							this.problem = response.data.data
						}
					} else {
						this.$message({
							type: 'error',
							message: '操作失败!' + response.data.msg
						});
					}
					this.problem.id = this.problemId
					this.loading = false
				});
			},
			showImages() {
				var url = 'framework/Common/queryImage.do'
				var param = {
					fid: this.problemId
				}
				axios.get(url, param).then(response => {
					if (response.data.code == '0') {
						this.images = response.data.data
					} else {
						this.$message({
							type: 'error',
							message: '查询失败' + response.data.msg
						});
					}
				});
			},
			handlePictureCardPreview(file) {
				this.dialogTraveImageUrl = file.url;
				this.dialogTraveImg = true;
			},
			deletImg() {
				this.dialogShowImg = true;
			},
			eletedImgPath(row) {
				this.$confirm('确定移除 ?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url = 'framework/Common/removeImage.do'
					var param = {
						id: row.id,
					}
					axios.post(url, param).then(response => {
						if (response.data.code == '0') {
							this.$message({
								type: 'success',
								message: '删除成功!',
							});
							this.showImages()
						} else {
							this.$message({
								type: 'error',
								message: '删除失败' + response.data.msg
							});
						}
					});
				});
			},
		},
		mounted() {
			this.getByPrimaryKey()
			this.showImages()
		}
	}
</script>
<style>
	.problem {
		margin-top: 50px;
	}

	.problem .imageStyle {
		/* max-height: 100 px; */
		/* width: 100 px; */
	}
</style>



// WEBPACK FOOTER //
// src/view/framework/problem/dealdetail.vue